import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcInputStyles } from 'components/filter/MprcInputStyles';
import { AutoCompleteDataModel } from 'components/MprcAutoComplete';
import { StickerAppliesTo } from 'generated/CoreApi_v1';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StickerAutoComplete } from 'views/foundation/sticker/components/StickerAutoComplete';
import { IAdvFilterPickerProps } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const StickerPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onError, onApply, onCancel } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    const applyTo = filter.pickerParams as StickerAppliesTo;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <StickerAutoComplete
                    checkRestrictions
                    multiSelect={multiSelect}
                    placeholder={filter.placeholder ?? t(`AdvFilter.Picker.Sticker.Placeholder${multiSelect ? "_multi" : ""}`)}
                    selectedItems={selected}
                    autoFocus
                    applyTo={applyTo}
                    color="warning"
                    onChange={(items) => setSelected(items)}
                    onApply={handleApply}
                    onCancel={onCancel}
                    onError={onError}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
